import styled from "@emotion/styled";
import type { ComponentProps } from "react";

import { MediaIcon, type MediaIconType } from "./MediaIcon";

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  svg {
    height: 90px;
    width: 90px;
  }
`;

const Message = styled.span`
  font-size: ${({ theme }) => theme.fontSize};
`;

type Props = ComponentProps<"div"> & {
  message?: string;
  mediaIconType?: MediaIconType;
};

export const FakePreview = ({ message, mediaIconType, ...props }: Props) => (
  <ImageContainer {...props}>
    <MediaIcon type={mediaIconType} />
    {message && <Message>{message}</Message>}
  </ImageContainer>
);

// for FakePreview when used in a thumbnail (i.e. thumbnail view)
// just for the content. ideally it should just result in being rendered similar to if a screenshot image was there instead
export const MediaIconThumbnailContent = styled(FakePreview)`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;
  width: 100%;

  border-radius: 3px;
`;
